module.exports = __webpack_public_path__ + "26a52a4aae941576f766e3e72cb3414d.svg";